import React from 'react';
import './TurnstileField.css';

interface TurnstileFieldProps {
  containerId: string;
  error?: string;
  onRetry: () => void;
}

const TurnstileField: React.FC<TurnstileFieldProps> = ({ containerId, error, onRetry }) => (
  <div className="turnstile-field">
    <div id={containerId} className="d-flex justify-content-center mb-2" />
    {error ? (
      <div className="alert alert-danger py-2 turnstile-field__error" role="alert">
        <span>{error}</span>
        <button
          type="button"
          className="btn btn-sm btn-outline-danger turnstile-field__retry"
          onClick={onRetry}
        >
          Reload captcha
        </button>
      </div>
    ) : null}
  </div>
);

export default TurnstileField;
